<template>
  <card title="Details">
    <template v-for="detail in details">
      <DoctorDetailField v-if="detail.detail_name === 'doctor_id'"
                          :key="detail.detail_name"
                          :detail="detail"/>
      <base-input v-else
                  :key="detail.detail_name"
                  :label="detail.detail_name"
                  v-model="detail.detail_value"
                  :placeholder="detail.detail_name">
      </base-input>
    </template>
  </card>
</template>

<script>
import DoctorDetailField from '@/components/Entities/DoctorDetailField';

export default {
  props: ['details'],
  components: { DoctorDetailField },
}
</script>
